import React, { useState, useMemo } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import queryString from 'query-string'

import { SingleView } from '../components/ui'

import { onQuickFilter, getViolationIndex } from '../utils'

import {
  setView, setCapturesExhausted
} from '../redux/actions/select'

// import { postHistory } from '../redux/actions'

// import { refreshToken } from '../redux/actions/auth'

import { makeStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import ImageSearchIcon from '@material-ui/icons/ImageSearch'
import AnnouncementIcon from '@material-ui/icons/Announcement'
import Typography from '@material-ui/core/Typography'
import log from 'loglevel'

const useStyles = makeStyles((theme) => ({
  contentList: {
    width: '100%'
  },
  contentPaper: {
    maxHeight: '21.875em',
    width: '100%',
    backgroundColor: '#f5f5f5',
    overflow: 'scroll',
    marginTop: '1em'
    // marginBottom: '1em'
  },
  contentGridShow: {
  },
  contentGridHide: {
    maxHeight: '0px',
    transition: '0.5s',
    overflow: 'hidden'
  },
  commentAvatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: '#3984f7'
  },
  margin: {
    margin: theme.spacing(0, 1, 1, 1),
    width: '100%'
  },
  postingAvatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: '#83b2ed'
  },
  postingField: {
    width: '75%'
  },
  postingIcon: {
    fontSize: '1em'
  },
  postingFab: {
    backgroundColor: '#A4D164',
    color: '#fff',
    width: theme.spacing(5),
    height: theme.spacing(5),
    fontSize: '1.25em',
    '&:hover': {
      backgroundColor: '#719E31'
    }
  },
  unpostingFab: {
    backgroundColor: '#B7C5D0',
    color: '#fff',
    width: theme.spacing(5),
    height: theme.spacing(5),
    fontSize: '1.5em',
    '&:hover': {
      backgroundColor: '#84929D'
    }
  },
  saveFab: {
    backgroundColor: '#A4D164',
    color: '#fff',
    width: theme.spacing(4),
    height: theme.spacing(4),
    '&:hover': {
      backgroundColor: '#719E31'
    }
  },
  discardFab: {
    backgroundColor: '#B7C5D0',
    color: '#fff',
    width: theme.spacing(4),
    height: theme.spacing(4),
    '&:hover': {
      backgroundColor: '#84929D'
    }
  },
  mild: {
    background: '#5291fc'
  },
  okay: {
    background: '#4e179a',
    color: '#ffffff'
  },
  notGreat: {
    background: '#e7840f',
    color: '#ffffff'
  },
  warn: {
    background: '#f5d818',
    color: '#414342'
  },
  bad: {
    background: '#d31111',
    color: '#ffffff'
  },
  newStatus: {
    borderTop: '10px solid #CB9BFF'
  },
  problemStatus: {
    borderTop: '10px solid #FFA593'
  },
  noProblemStatus: {
    borderTop: '10px solid #96E1A8'
  },
  holdStatus: {
    borderTop: '10px solid #ffff91'
  },
  solvedStatus: {
    borderTop: '10px solid #A6FFFF'
  },
  changedStatus: {
    borderTop: '10px solid #ffa500'
  },
  singleChip: {
    backgroundColor: '#A4D164',
    color: '#fff',
    // width: theme.spacing(5),
    height: theme.spacing(5),
    fontWeight: 600,
    fontSize: '1.5em'
  },
  accordionDetails: {
    backgroundColor: '#f5f5f5',
    borderRadius: '1em',
    margin: theme.spacing(0, 2, 2, 2)
  },
  contentAccordion: {
    boxShadow: theme.shadows[5],
    border: '1px solid rgba(0, 0, 0, 0.12)'
    // border: '0.01em solid #3984f7'
    // border: '0.01em solid #3984f7'
  },
  detailAccordion: {
    boxShadow: 'none'
  },
  greenBtn: {
    color: '#A4D164',
    border: '1px solid rgba(164, 209, 100, 0.75)',
    // backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: 'rgba(164, 209, 100, 0.15)',
      border: '1px solid rgba(164, 209, 100, 1)'
    }
  },
  tileBar: {
    backgroundColor: 'rgba(57, 132, 247, 0.75)',
    color: '#000',
    pointerEvents: 'none'
  },
  buttonColor: {
    backgroundColor: '#007BFF',
    color: '#FFFFF'
  },
  buttonQuarantinedColor: {
    backgroundColor: '#88ae53',
    color: '#FFFFF',
    '&:hover': {
      backgroundColor: 'rgba(164, 209, 100, 0.75)'
    }
  },
  quarantineMenuItem: {
    color: '#3984f7',
    fontWeight: 600,
    textTransform: 'capitalize'
  },
  imageContainer: {
    // overflowY: 'scroll'
  },
  detailsContainer: {
    // overflowY: 'scroll'
  },
  flagBtn: {
    position: 'fixed'
  },
  sidebarContainer: {
    // background: theme.palette.background.default
    // background: theme.palette.action.hover,
    boxShadow: theme.shadows[3]
  },
  flagAvatar: {
    backgroundColor: theme.palette.error.light
  },
  flagContainer: {
    position: 'absolute',
    height: 'auto',
    width: 'auto',
    pointerEvents: 'none'
  },
  arrowIcons: {
    fontSize: '60px'
  },
  arrowColor: {
    color: '#FFFFFF',
    '&:focus': {
      outline: 'none'
    }
  },
  paperRoot: {
    backgroundColor: '#3134384a'
  },
  whiteText: {
    color: '#FFFFFF'
  },
  setFilterRoot: {
    backgroundColor: '#3984F7'
  },
  phraseButton: {
    fontWeight: '600',
    '&:disabled': {
      color: '#5e5d5d'
    }
  }
}))

const CaptureSingleView = props => {
  const { fromLink } = props

  const dispatch = useDispatch()
  const classes = useStyles()

  const { captures: rxCaptures, hits } = useSelector(state => state.violations.violations)
  const { PageCaptureLimit, CapturesExhausted: capturesExhausted } = useSelector(state => state.selection)

  const [parsedProps, setParsedProps] = useState({ view: '', page: 0, captureTrgts: null })
  const [captureInfo, setCaptureInfo] = useState({})

  useMemo(() => {
    if (props.location && Boolean(props.location.search) && typeof PageCaptureLimit === 'number') {
      try {
        const searchProps = queryString.parse(props.location.search)

        if (searchProps && typeof searchProps === 'object' && Boolean(searchProps.view)) {
          // !!TO DO: This logic is duplicated numerous times in various files. Need to move to util or move this memo to a parent component of all files in which it is used.
          const captureTrgts = (() => {
            switch (searchProps.view) {
              case 'single': {
                try {
                  // capture (singular) returns a number string, with a 1 based index
                  return parseInt(searchProps.capture) || null
                } catch (err) {
                  return null
                }
              }
              case 'grid': {
                try {
                  // active captures (plural) in grid view returns an array (considered truthy even when empty so the following logic will work as expected)
                  return JSON.parse(searchProps.activeCaptures) || null
                } catch (err) {
                  return null
                }
              }
              case 'list': {
                try {
                  // active capture (singular) in list view returns a number string, with a 0 based index.
                  // Previously this used the same logic as the 'single' case. However as it was 0 based, the `parseInt(searchProps.activeCapture) || null` always returned null at the first index as 0 is falsey
                  const parsedCaptureNum = parseInt(searchProps.activeCapture)
                  if (!isNaN(parsedCaptureNum)) {
                    return parsedCaptureNum
                  } else {
                    return null
                  }
                } catch (err) {
                  return null
                }
              }
              default: return null
            }
          })()

          const page = (() => {
            if (searchProps.view === 'single' && typeof captureTrgts === 'number') { return Math.floor((captureTrgts - 1) / PageCaptureLimit) + 1 }
            return parseInt(searchProps.page) || 0
          })()

          setParsedProps({ view: searchProps.view, page, captureTrgts })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }, [props.location, PageCaptureLimit])

  useMemo(() => {
    if (Array.isArray(rxCaptures) && Boolean(parsedProps.view) && typeof hits === 'number' && typeof parsedProps.captureTrgts === 'number') {
      log.info('repopulating views')
      dispatch(setView('single-view'))

      const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, pageLimit: PageCaptureLimit, page: parsedProps.page, currentView: 'single' })
      const captureTrgt = (() => {
        if (typeof captureIx === 'number') { return rxCaptures[captureIx] }
        return {}
      })()

      if (Boolean(rxCaptures.length) && !fromLink && parsedProps.captureTrgts > hits) {
        dispatch(setCapturesExhausted(true))
      } else {
        dispatch(setCapturesExhausted(false))
      }

      if (Boolean(rxCaptures.length) && typeof captureTrgt === 'object' && Boolean(captureTrgt.violationID)) {
        setCaptureInfo(captureTrgt)
      }
    }
  }, [rxCaptures, fromLink, dispatch, PageCaptureLimit, hits, parsedProps])

  return (
    <>
      <Grid container direction='row' justify='center' className='mb-4 mt-4 pb-4'>
        {
          captureInfo && Boolean(captureInfo.violationID)
            ? (
              <>
                <Grid item xs={1} />
                <Grid item xs={10}>
                  <SingleView
                    capture={captureInfo}
                    onQuickFilter={onQuickFilter}
                    useStyles={useStyles}
                    Captures={rxCaptures}
                  />
                </Grid>
              </>)
            : (
              <Grid item xs={9}>
                <Grid
                  container
                  direction='row'
                  justify='center'
                  className='w-100 mx-auto'
                  style={{
                    height: '15em',
                    maxWidth: '40em',
                    marginTop: '4em'
                  }}
                >
                  <Paper
                    className='w-100 mx-auto'
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                    classes={{ root: classes.paperRoot }}
                    elevation={3}
                  >
                    <Grid container item direction='column' justify='center' alignContent='center'>
                      <Grid container item justify='center' alignContent='center'>
                        {capturesExhausted === true
                          ? <AnnouncementIcon style={{ fontSize: 'xxx-large' }} color='primary' classes={{ colorPrimary: classes.whiteText }} />
                          : <ImageSearchIcon style={{ fontSize: 'xxx-large' }} color='primary' classes={{ colorPrimary: classes.whiteText }} />}
                      </Grid>
                      <Grid container item justify='center' alignContent='center'>
                        {capturesExhausted &&
                          <Typography
                            variant='h5'
                            color='primary'
                            classes={{ colorPrimary: classes.whiteText }}
                            style={{ fontWeight: 'bold' }}
                            className='mt-2'
                          >
                            Heads up!
                          </Typography>}
                        <Typography
                          variant='h6'
                          color='primary'
                          classes={{ colorPrimary: classes.whiteText }}
                          className='mt-2'
                        >
                          No captures found. Try clearing any saved filters or hitting "refresh".
                        </Typography>
                        {capturesExhausted &&
                          <Typography
                            variant='h6'
                            color='primary'
                            classes={{ colorPrimary: classes.whiteText }}
                            className='mt-1'
                          >
                            Please use a filter to refine your results.
                          </Typography>}
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>)
        }
      </Grid>
    </>
  )
}

export default withRouter(CaptureSingleView)
